import { reactLocalStorage } from 'reactjs-localstorage';

import Const from './Constants';

class LocalStorage {

  static Model = 1;
  static Options = 2;
  static Permission = 3;

  static getWhatsAppTemplate = type => {
    if(type === LocalStorage.Options) {
      return reactLocalStorage.getObject(Const.Model).whatsapp_temp.options;
    }
    return reactLocalStorage.getObject(Const.Model).whatsapp_temp;
  }

  static getApis = type => {
    if(type === LocalStorage.Options) {
      return reactLocalStorage.getObject(Const.Model).api.options;
    }
    return reactLocalStorage.getObject(Const.Model).api;
  }
}
export default LocalStorage;